module.exports = __webpack_public_path__ + "img/business.c3de255d.png";